<template lang="pug">
  .relationship__wrap
    .relationship__details(v-if="(relationshipType === 'parent' || showFund)")
      table-row(v-for="(row, i) in detailsData" :item="row" :parentType="getChallengeData" :key="i + row.jsonPath")
      p.relationship__action(v-if="isNonFund" @click="showFields") {{showException}}
      table-row(
        v-if="showField" v-for="(row, i) in exceptionData"
        :parentType="getChallengeData"
        :item="row"
        :key="i + row.jsonPath")
    .relationship__details(v-if="relationshipType === 'exception'")
      table-row(v-for="(row, i) in exceptionData" :parentType="getChallengeData" :item="row" :key="i + row.jsonPath")
      p.relationship__action(@click="showFields") {{showData}}
      table-row(
        v-if="showField"
        v-for="(row, i) in detailsData"
        :parentType="getChallengeData"
        :item="row"
        :key="i + row.jsonPath")

    .relationship__nonexisting(v-if="isFundNonExisting") {{nonAvailableTest}}
</template>
<script>
import { mapState, mapMutations, mapGetters, } from 'vuex'
import {
  TOGGLE_CHALLENGE_RELATIONSHIP_DETAILS_MODAL,
  TOGGLE_CHALLENGE_RELATIONSHIP_MODAL,
  SET_RELATIONSHIP_DETAILS,
  SET_PARENT_TYPE,
} from '@/store/modules/record/modules/challenge/mutations-types'
import Challenge from '@/mixins/challenge'
import TableRow from '@/components/record-details/table-components/TableRow'

export default {
  components: { TableRow, },
  provide: {
    isSeparated: false,
  },
  mixins: [ Challenge, ],
  props: {
    type: {
      type: String,
      default: 'directParent',
      validator: (value) => [
        'directParent',
        'ultimateParent',
        'fundManager',
        'umbrellaFund',
        'masterFund',
        'headOffice',
      ].includes(value),
    },
    tableData: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data () {
    return {
      detailsData: [],
      exceptionData: [],
      relationshipType: null,
      showField: false,
    }
  },
  computed: {
    isFundNonExisting () {
      return this.parentType === 'nonExisting' && this.relationshipType === 'nonExisting'
    },
    nonAvailableTest () {
      return this.type === 'headOffice' ? 'no head office relationship' : 'no fund relationship'
    },
    parentType () {
      return this.getCurrentRelationshipTypes[this.type]
    },
    showFund (){
      return this.parentType === 'parent' && !this.isNonFund
    },
    isNonFund () {
      return this.type === 'directParent' || this.type === 'ultimateParent'
    },
    getChallengeData () {
      return {
        parent: this.type,
        currentParentType: this.relationshipType,
        updatedParentType: this.parentType,
      }
    },
    showException () {
      return this.showField ? 'Hide 2 more fields' : 'Show 2 more fields'
    },
    showData () {
      return this.showField ? 'Hide 5 more fields' : 'Show 5 more fields'
    },
    ...mapState('record/challenge', [ 'fields', ]),
    ...mapGetters('record', [ 'getCurrentRelationshipTypes', ]),
  },
  watch: {
    parentType () {
      this.showField = true
    },
  },
  created () {
    this.sortData()
    this.relationshipType = this.getCurrentRelationshipTypes[this.type]
  },
  methods: {
    sortData () {
      if (this.tableData && this.tableData.length) {
        this.tableData.forEach((item) => {
          if (item.type === 'exception') this.exceptionData.push(item)
          else this.detailsData.push(item)
        })
      }
    },

    showFields () {
      this.showField = !this.showField
    },
    changeRelationshipType () {
      this.setRelationshipType({
        type: this.type,
      })
    },
    openModal (action) {
      this.changeRelationshipType()
      if (action === 'modify') {
        this.setRelationshipDetails({
          data: this.relationshipType === 'parent' ? this.detailsData : this.exceptionData,
        })
        this.toggleRelationshipDetailsModal(this.relationshipType)
      } else {
        this.toggleRelationshipModal(action)
      }
    },

    ...mapMutations('record/challenge', {
      toggleRelationshipDetailsModal: TOGGLE_CHALLENGE_RELATIONSHIP_DETAILS_MODAL,
      toggleRelationshipModal: TOGGLE_CHALLENGE_RELATIONSHIP_MODAL,
      setRelationshipType: SET_PARENT_TYPE,
      setRelationshipDetails: SET_RELATIONSHIP_DETAILS,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../../assets/styles/variables.styl"

  .relationship
    &__details
      display flex
      flex 1
      flex-direction column

    &__nonexisting
      background $default-color-light-2
      line-height 1.5
      padding 1rem 1.8rem

    &__action
      cursor pointer
      text-decoration underline
      margin 15px 0
      color $primary-color
      @media (max-width: $tablet)
        padding 0 20px
        font-size 90%

    &__icon
      display none
      position absolute
      background $white-color
      border-radius 50%
      border 1px solid $primary-hover
      box-shadow 1px 4px 6px -2px rgba(0,0,0,0.69)
      height 40px
      width 40px

</style>



// WEBPACK FOOTER //
// src/components/record-details/table-components/RelationshipDetails.vue